import EventEmitter from '@/services/EventEmitter';

export default class AbstractVideoProcessor {
  constructor(video1, video2, options) {
    this.initOptions(options);
    this.isFirstVideoEnabled = false;
    this.video1 = video1;
    this.video2 = video2;
    this.emitter = new EventEmitter();
  }

  initOptions(options) {
    this.options = options || {};
    if (!this.options.skipIntervalSec) this.options.skipIntervalSec = 30;
  }

  bindEvents() {}

  play(src) {
    const video = this.getOtherVideo();
    this.isFirstVideoEnabled = !this.isFirstVideoEnabled;
    video.setAttribute('src', src);
    this.unmute(video);
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.finally(() => this.setSkipInterval(video));
    } else {
      this.setSkipInterval(video);
    }
  }

  getMainVideo() {
    return this.isFirstVideoEnabled ? this.video1 : this.video2;
  }

  getOtherVideo() {
    return this.isFirstVideoEnabled ? this.video2 : this.video1;
  }

  unmute(video) {
    this.emitter.emit('video:unmute', video);
  }

  setSkipInterval(video) {
    this.skipTimeout = this.initSkipTimeout(video);
  }

  initSkipTimeout(video, lastMediaTime = 0) {
    return setTimeout(() => {
      if (lastMediaTime === video.currentTime) {
        console.log(`Медиа элемент ${video.id} не воспроизвелся в течение ${this.options.skipIntervalSec} секунд, переключаем на следующее`);
        this.skipVideo(video);
      } else {
        this.skipTimeout = this.initSkipTimeout(video, video.currentTime);
      }
    }, this.options.skipIntervalSec * 1000);
  }

  stop(video) {
    video.pause();
    video.currentTime = 0;
  }

  destroy() {}
}
